import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import NotificationService from '../../services/NotificationService';
import AuthService from '../../services/AuthService';
import { MemberLinkBtnDeepLilac } from '../../styles/Elements';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import Login from '../../pages/Login';
export default class NotificationCreate extends Component {
    constructor() {
        super()
        this.state = {
          haveRoleOfAdminOrMod:false,            
          selectedFile: null,
            subject: '',
            description:''
       
        };
        this.onChangeSubject = this.onChangeSubject.bind(this);
        this.onChangeDesc = this.onChangeDesc.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

    }


    componentDidMount() {
      this.checkSession();

  }
  checkSession = () => {
      const loggedInUser = AuthService.getCurrentUser();
      const whatRole = AuthService.getUserRole();
      if (loggedInUser) {
          if (whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
              this.setState({ haveRoleOfAdminOrMod: true });
          }
      }      
      }
  

    onChangeSubject(event) {
        this.setState({subject: event.target.value })
    }

    onChangeDesc(event) {
      this.setState({ description: event.target.value })
  }



    onSubmit(event) {
        event.preventDefault()
        this.setState({
            message: "",
            loading: true
          });
      this.form.validateAll();
      if (this.checkBtn.context._errors.length === 0) {
          this.fileUpalodHandler();
      } else {
        this.setState({
            loading: false
          });  
      }
    }




    fileSelectedHandler = event => {
        this.setState({
            selectedFile: event.target.files[0]
        })
    }

    fileUpalodHandler = () => {
        const fileData = new FormData();
        fileData.append('file', this.state.selectedFile)
        fileData.append('notificationSubject',this.state.subject);
        fileData.append('notificationDescription',this.state.description);
        fileData.set('notificationcreatedBy',AuthService.getCurrentUser().id);
        this.createNotif(fileData);
    }

    createNotif(data) {
        return NotificationService.createNotification(data)
        .then(res => {
             alert("Uploaded Successfully !");
             window.open('/family-notification',"_self");
        },
        error => { 
             const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
            if(resMessage === "") {
                alert("Please Try Again!");
            } else {
                alert(resMessage);
            }
        
         // window.location.reload();
        }
      );
    }


    render() {
        const required = value => {
            if (!value) {
              return (
                <div className="alertDanger" >
                     <p className="alertDanger">  
               اجباري         
                </p> 
                </div>
              );
            }
          };
    
        return (
      <div>
          {!this.state.haveRoleOfAdminOrMod ? 
           <div>
           <Login></Login>
       </div> :
            <div className="top-level-page-main notification-create">
  <div className="view-profile">
  <div className="profile-details">
  <Form onSubmit={this.onSubmit}
   ref={c => {
    this.form = c;
  }}>
      
                                 <div className="form-group-create">
                                 <h1>اضافة اشعار جديد</h1>
                                        <h5> عنوان الاشعار </h5> 
                                        <Input
                                        type="text"
                                            name="subject" placeholder="العنوان"
                                            value={this.state.subject}
                                            onChange={this.onChangeSubject}
                                            validations={[required]}
                                        />
                                    </div>

                                    <div className="form-group-create">
                  <h5 htmlFor="mailContent">معلومات اضافيّة</h5>
                <textarea className="form-control contentarea"
                rows="10"
                name="mailContent"
                value={this.state.description}
                onChange={this.onChangeDesc}
                validations={[required]}
/>

                </div>

                                    
                                    <div className="form-group-create">
                                    <div className="actionsProfile">          
<input type='file' onChange={this.fileSelectedHandler} />                    
<button className="btn" 
 disabled={this.state.loading}>
       {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
 اضافة اشعار </button>
 </div>
 {this.state.message && (
                <div className="form-group-create">
                  <div
                    className={
                      this.state.successful
                        ? "alertSuccess"
                        : "alertDanger"
                    }
                    role="alert"
                  >
                    {this.state.message}
                  </div>
                </div>
              )}
  <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
            </div>
            </Form> 
               
                    <MemberLinkBtnDeepLilac to={'/adminboard/'}> Back to Admin Board  </MemberLinkBtnDeepLilac>
  
 
      </div>
  </div>
        </div>
    }</div>

        )
    }
}
